/* ----------------- React Native Paper --------------- */
import { Card } from "react-native-paper";

import Button from "../../Button";
import CardContainer from "../../CardContainer";
/* ----------------- Components --------------- */
import CardContent, { type MasteryListItemProps } from "./CardContent";

export type StudySessionMasteryTagProgressCardProps = {
	title: string;
	subtitle: string;
	items: MasteryListItemProps[];
	handleClickCard?: () => void;
	cta?: string;
	icon?: string;
	tooltip?: string;
	tagType?: string;
	handleClickInfo?: (text: string) => void;
	showViewAll?: boolean;
};
export const StudySessionMasteryTagProgressCard = ({
	title,
	subtitle,
	items,
	handleClickCard,
	cta,
	icon,
	tooltip,
	tagType,
	handleClickInfo,
	showViewAll = false,
}: StudySessionMasteryTagProgressCardProps) => {
	const shouldShowViewAll =
		showViewAll || ((cta || handleClickCard) && items.length > 3);
	const finalItems = items.slice(0, 4);

	const ActionsCard = () => {
		if (shouldShowViewAll) {
			return (
				<Card.Actions>
					<Button mode="text" onPress={handleClickCard}>
						{cta || "View topics"}
					</Button>
				</Card.Actions>
			);
		}
		return null;
	};

	return (
		<CardContainer
			title={title}
			subtitle={subtitle}
			icon={icon || "tag-multiple-outline"}
			onPress={showViewAll ? handleClickCard : undefined}
			actions={<ActionsCard />}
			tooltip={tooltip}
			handleClickInfo={handleClickInfo}
		>
			<CardContent items={finalItems} tagType={tagType} />
		</CardContainer>
	);
};
